








import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation, State } from 'vuex-class'

import { HIDE_NEW_VERSION_NOTIFICATION } from '@/store/mutations'

import { WebSocket } from './components'

import { isFood } from '@/utils'

@Component({
  components: {
    WebSocket
  }
})
export default class App extends Vue {
  @Ref()
  readonly soundNotification?: HTMLAudioElement

  @State
  readonly showNewVersionNotification!: boolean

  @Getter('auth/isAuthenticated')
  readonly isAuthenticated!: boolean

  @Action
  readonly loadBusinessUnit!: () => Promise<void>

  @Action
  readonly loadProfile!: () => Promise<void>

  @Mutation(HIDE_NEW_VERSION_NOTIFICATION)
  hideNewVersionNotification!: () => void

  @Watch('showNewVersionNotification')
  onShowNewVersionNotificationChange (show: boolean) {
    if (show) {
      this.$vs.notify({
        title: 'Nova versão disponível',
        text: 'Toque para atualizar.',
        color: 'dark',
        fullWidth: true,
        fixed: true,
        click: () => {
          this.hideNewVersionNotification()

          if (this.$serviceWorker) {
            this.$serviceWorker.skipWaiting()
          }
        }
      })
    }
  }

  created () {
    if (this.isAuthenticated) {
      this.loadProfile()
      this.loadBusinessUnit()
    }
    document.title = isFood() ? 'Filazero Food' : 'Filazero Store'
  }

  emitSoundNotification () {
    if (this.soundNotification) {
      this.soundNotification.play()
    }
  }
}
